import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { Calendar, dayjsLocalizer, View } from "react-big-calendar";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  getJobListAction,
  getWorkDiaryAction,
  setUpdateWorkDiaryResponseAction,
  setWorkDiaryResponseAction,
} from "../../../store/reducers/workDiarySlice";
import ManageTask from "./ManageTask";
import updateLocale from "dayjs/plugin/updateLocale"; // Import the updateLocale plugin
import timezone from "dayjs/plugin/timezone";
import "./calender.css";
import { useNavigate } from "react-router-dom";
const WorkDiary = () => {
  const currentDate = new Date();

  // Add updateLocale plugin to dayjs
  dayjs.extend(updateLocale);
  dayjs.extend(timezone);
  // Update locale to start the week on Monday
  dayjs.updateLocale("en", {
    week: {
      dow: 1, // Set Monday as the first day of the week (dow: 1)
    },
  });

  const localizer = dayjsLocalizer(dayjs);

  // Set the startOfWeek function to return 1 (Monday)
  localizer.startOfWeek = () => 1; // 1 corresponds to Monday (Sunday is 0)

  // Define offset in hours and minutes
  const offsetHours = 5;
  const offsetMinutes = 30;

  const dispatch = useDispatch();
  const { userProfile } = useSelector((state: any) => state?.user);
  const {
    workDiaryData,
    isWorkDiarySuccess,
    isWorkDiaryUpdateSuccess,
    jobListData,
  } = useSelector((state: any) => state?.workDiary);

  useEffect(() => {
    dispatch(getWorkDiaryAction({startDate: currentDate.toISOString().split("T")[0], endDate: currentDate.toISOString().split("T")[0]}));
    dispatch(getJobListAction());
    dispatch(setWorkDiaryResponseAction(false));
    dispatch(setUpdateWorkDiaryResponseAction(false));
  }, [dispatch, isWorkDiarySuccess, isWorkDiaryUpdateSuccess]);

  // Transform the surveyDiaryData to fit the calendar events format
  const transformedWorkDiaryEvents = workDiaryData.map((event: any) => {
    // Combine the date with start_time and end_time to form valid Date objects
    const startDateTime = new Date(
      `${event.date.split("T")[0]}T${event.start_time}`
    );
    const endDateTime = new Date(
      `${event.date.split("T")[0]}T${event.end_time}`
    );

    return {
      id: event.task_id,
      title: `${event.title} || ${event?.location}`,
      start: startDateTime, // Convert start_time to a full Date object
      end: endDateTime, // Convert end_time to a full Date object
      allDay: false, // Adjust this as needed for full-day events
      description: event.description,
      status: event.status,
    };
  });

  console.log("jobListData", jobListData);
  // Transform jobListData into calendar events format
  const transformedJobListEvents = jobListData.map((job: any) => {
    const startDateTime = dayjs
      .utc(job.start_date_time)
      .subtract(offsetHours, "hour")
      .subtract(offsetMinutes, "minute")
      // .tz("Europe/London")
      .toDate();
    const endDateTime = dayjs
      .utc(job.end_date_time)
      .subtract(offsetHours, "hour")
      .subtract(offsetMinutes, "minute")
      // .tz("Europe/London")
      .toDate();

       const collection = job.collection_addresses?.[0] || {};
  const delivery = job.delivery_addresses?.[0] || {};

  const collectionAddress = `${collection.street || ""}, ${collection.town || ""} (${collection.postcode || ""})${collection.country ? `, ${collection.country}` : ""}`;
  const deliveryAddress = `${delivery.street || ""}, ${delivery.town || ""} (${delivery.postcode || ""})${delivery.country ? `, ${delivery.country}` : ""}`;

    return {
      id: job.job_id,
      title: job?.is_confirmation_pending
        ? `T&C confirmation pending || ${job.job_title} || ${job.job_type}`
        : `${job.job_title} || ${job.job_type}`,
      start: startDateTime,
      end: endDateTime,
      allDay: false,
      description: job.note || `Lead: ${job.lead_id}`,
      status: job.status,
      customer: {
        name: job.customer_name,
        email: job.customer_email,
        phone: job.customer_phone,
      },
      jobType: job.job_type,
      isConfirmationPending: job?.is_confirmation_pending,
       location: `${collectionAddress} to ${deliveryAddress}`,
       leadId: job?.lead_id,
    };
  });

  console.log("transformedJobListEvents", transformedJobListEvents);

  // Merge both event lists into a single array
  const mergedEvents = [
    ...transformedWorkDiaryEvents,
    ...transformedJobListEvents,
  ];

  console.log("mergedEvents", mergedEvents);
  // Custom event component to show time in the month view
  const EventComponent = ({ event }: any) => (
    <span>
      <span style={{ fontSize: "14px" }}>
        {" "}
        {dayjs(event.start).format("h:mm A")} -{" "}
        {dayjs(event.end).format("h:mm A")}
      </span>
      <br /> {event.title}
    </span>
  );

  const [view, setView] = useState<View>("day");
  const [open, setOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState("");

  const handleOpen = (event?: any) => {
    setOpen(true);
  };
  const handleSelectEvent = (event: any) => {
    setSelectedTask(event?.id);
    handleOpen(event);
  };
 const navigate = useNavigate();
  const handleJobEvent = (event: any) => {
    console.log("event-147", event);
    sessionStorage.setItem("selectedJobLeadId", JSON.stringify(event?.leadId));
    navigate('/dashboard');
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedTask("");
  };

    const formats = {
    agendaHeaderFormat: ({ start, end }: { start: Date; end: Date }) =>
      `${dayjs(start).format(userProfile?.dateFormat ? userProfile?.dateFormat : "DD/MM/YYYY")} - ${dayjs(end).format(userProfile?.dateFormat ? userProfile?.dateFormat : "DD/MM/YYYY")}`,
  };

  return (
    <>
      {open && (
        <ManageTask
          selectedTask={selectedTask}
          open={open}
          onHide={handleClose}
          title="SCHEDULE A TASK"
        />
      )}

      <Calendar
        className="bigCalendar"
        localizer={localizer}
        events={mergedEvents ? mergedEvents : []}
        startAccessor="start"
        endAccessor="end"
        style={{
          height: "100%",
          whiteSpace: "normal",
          maxHeight: "auto",
          overflow: "hidden",
        }}
        onSelectEvent={(event) =>
          event.jobType === "job" ? handleJobEvent(event) : handleSelectEvent(event)
        }
        selectable={true} // Enable date slot selection
        // onSelectSlot={handleSelectSlot} // Handle date slot selection
        step={15} // Defines each time slot as 30 minutes
        timeslots={1} // Defines two 30-minute slots per hour
        view={view}
        formats={formats}
        onView={(newView) => setView(newView)} // Update view state when calendar view changes
        defaultDate={currentDate} // Set the date state
        min={
          new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate(),
            0,
            0,
            0
          )
        } // Midnight
        max={
          new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate(),
            23,
            59,
            59
          )
        } // 11:59 PM
        scrollToTime={
          new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate(),
            7,
            0,
            0
          )
        } // Scroll to 7 AM
        // popup={true}
        // dayPropGetter={dayPropGetter}

        eventPropGetter={(event) => ({
          style: {
            whiteSpace: "wrap !important",
            minHeight: "auto",
            height: "auto",
            backgroundColor:
              event.jobType === "job"
                ? event.isConfirmationPending
                  ? "#E316B8"
                  : "#cc5500"
                : "#3174AD",
          },
        })}
        components={{
          event: view === "month" ? EventComponent : undefined, // Use custom event component to display time in month view
        }}
        // Limit maximum visible events per day to 2
        messages={{ showMore: (total) => `+${total} more` }}
       
      />
    </>
  );
};
export default WorkDiary;
